export default "/packs/images/header~24332fbdd6a91de1a72dd7d1bf6e2d68.svg";